// Generated by purs version 0.13.0
"use strict";
var Chip_Action = require("../Chip.Action/index.js");
var Chip_Model_DieReason = require("../Chip.Model.DieReason/index.js");
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Chip_Model_Inventory = require("../Chip.Model.Inventory/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var Chip_Model_Level = require("../Chip.Model.Level/index.js");
var Chip_Model_SwitchState = require("../Chip.Model.SwitchState/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var Chip_Model_WallType = require("../Chip.Model.WallType/index.js");
var Chip_Mutation_Direction = require("../Chip.Mutation.Direction/index.js");
var Chip_Mutation_Inventory = require("../Chip.Mutation.Inventory/index.js");
var Chip_Mutation_Level = require("../Chip.Mutation.Level/index.js");
var Chip_Mutation_Point = require("../Chip.Mutation.Point/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var stepInWater = function (level) {
    if (level.inventory.flippers) {
        return Chip_Action.inactive(level);
    };
    if (Data_Boolean.otherwise) {
        return Chip_Action.withAction(level)(new Chip_Action.Die(Chip_Model_DieReason.Drown.value));
    };
    throw new Error("Failed pattern match at Chip.Action.MovePlayer (line 164, column 1 - line 164, column 43): " + [ level.constructor.name ]);
};
var stepInFire = function (level) {
    if (level.inventory.fireBoots) {
        return Chip_Action.inactive(level);
    };
    if (Data_Boolean.otherwise) {
        return Chip_Action.withAction(level)(new Chip_Action.Die(Chip_Model_DieReason.Burned.value));
    };
    throw new Error("Failed pattern match at Chip.Action.MovePlayer (line 169, column 1 - line 169, column 42): " + [ level.constructor.name ]);
};
var sound = function (effect) {
    return function (level) {
        return Chip_Action.withAction(level)(new Chip_Action.PlaySound(effect));
    };
};
var nextTeleport = function (canPush) {
    return function (origin) {
        return function (direction) {
            return function (v) {
                var isSolid = function (pos) {
                    var v1 = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(pos)(v.tiles);
                    if (v1 instanceof Data_Maybe.Just && v1.value0 instanceof Chip_Model_Tile.Wall) {
                        return true;
                    };
                    if (Data_Set.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(pos)(v.blocks)) {
                        return !canPush;
                    };
                    if (Chip_Model_Level.hasEnemy(pos)(v)) {
                        return true;
                    };
                    return false;
                };
                var iter = function ($copy_v1) {
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v1) {
                        if (v1.x === -1) {
                            $copy_v1 = {
                                x: Chip_Model_Level.mapSize - 1 | 0,
                                y: v1.y - 1 | 0
                            };
                            return;
                        };
                        if (v1.y === -1) {
                            $copy_v1 = {
                                x: Chip_Model_Level.mapSize - 1 | 0,
                                y: Chip_Model_Level.mapSize - 1 | 0
                            };
                            return;
                        };
                        var v2 = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                            return "y";
                        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                            return "x";
                        }))(Data_Ord.ordInt)))(v1)(v.tiles);
                        if (Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                            return "y";
                        }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                            return "x";
                        }))(Data_Eq.eqInt)))(v1)(origin)) {
                            $tco_done = true;
                            return Data_Maybe.Nothing.value;
                        };
                        if (v2 instanceof Data_Maybe.Just && (v2.value0 instanceof Chip_Model_Tile.Teleport && !isSolid(Chip_Mutation_Point.adjustPoint(v1)(direction)))) {
                            $tco_done = true;
                            return new Data_Maybe.Just(Chip_Mutation_Point.adjustPoint(v1)(direction));
                        };
                        $copy_v1 = {
                            x: v1.x - 1 | 0,
                            y: v1.y
                        };
                        return;
                    };
                    while (!$tco_done) {
                        $tco_result = $tco_loop($copy_v1);
                    };
                    return $tco_result;
                };
                return iter({
                    x: origin.x - 1 | 0,
                    y: origin.y
                });
            };
        };
    };
};
var checkForEnemies = function (v) {
    if (Chip_Model_Level.hasEnemy(v.result.player.pos)(v.result)) {
        return {
            result: v.result,
            actions: Data_Array.cons(new Chip_Action.Die(Chip_Model_DieReason.Eaten.value))(v.actions)
        };
    };
    if (Data_Boolean.otherwise) {
        return {
            result: v.result,
            actions: v.actions
        };
    };
    throw new Error("Failed pattern match at Chip.Action.MovePlayer (line 195, column 1 - line 195, column 60): " + [ v.constructor.name ]);
};
var movePlayerTo = function (manually) {
    return function (direction) {
        return function (dest) {
            return function (level) {
                var turned = {
                    player: {
                        pos: level.player.pos,
                        direction: direction,
                        turnedAt: level.tick,
                        movedAt: (function () {
                            if (manually) {
                                return level.tick;
                            };
                            return level.player.movedAt;
                        })()
                    },
                    tiles: level.tiles,
                    inventory: level.inventory,
                    chipsLeft: level.chipsLeft,
                    hint: level.hint,
                    enemies: level.enemies,
                    blocks: level.blocks,
                    trapConnections: level.trapConnections,
                    ticksLeft: level.ticksLeft,
                    tick: level.tick
                };
                var moved = {
                    player: {
                        pos: dest,
                        direction: turned.player.direction,
                        turnedAt: turned.player.turnedAt,
                        movedAt: turned.player.movedAt
                    },
                    tiles: turned.tiles,
                    inventory: turned.inventory,
                    chipsLeft: turned.chipsLeft,
                    hint: turned.hint,
                    enemies: turned.enemies,
                    blocks: turned.blocks,
                    trapConnections: turned.trapConnections,
                    ticksLeft: turned.ticksLeft,
                    tick: turned.tick
                };
                var pushBlock = function (blockDest) {
                    var v = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(blockDest)(level.tiles);
                    if (Data_Set.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(blockDest)(level.blocks)) {
                        return Chip_Action.inactive(turned);
                    };
                    if (Chip_Model_Level.hasEnemy(blockDest)(level)) {
                        return Chip_Action.inactive(turned);
                    };
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Bomb) {
                        return movePlayer(manually)(direction)({
                            player: level.player,
                            tiles: Data_Map_Internal["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(blockDest)(level.tiles),
                            inventory: level.inventory,
                            chipsLeft: level.chipsLeft,
                            hint: level.hint,
                            enemies: level.enemies,
                            blocks: Data_Set["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(dest)(level.blocks),
                            trapConnections: level.trapConnections,
                            ticksLeft: level.ticksLeft,
                            tick: level.tick
                        });
                    };
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Teleport) {
                        var v1 = nextTeleport(false)(blockDest)(direction)(level);
                        if (v1 instanceof Data_Maybe.Just) {
                            return Chip_Action.addAction(new Chip_Action.PlaySound(Chip_Action.Teleported.value))(movePlayerTo(manually)(direction)(dest)(Chip_Mutation_Level.moveBlock(dest)(v1.value0)(level)));
                        };
                        if (v1 instanceof Data_Maybe.Nothing) {
                            return sound(Chip_Action.Oof.value)(turned);
                        };
                        throw new Error("Failed pattern match at Chip.Action.MovePlayer (line 151, column 22 - line 154, column 34): " + [ v1.constructor.name ]);
                    };
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Water) {
                        return Chip_Action.addAction(new Chip_Action.PlaySound(Chip_Action.Splash.value))(movePlayer(manually)(direction)({
                            player: level.player,
                            tiles: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(blockDest)(Chip_Model_Tile.Dirt.value)(moved.tiles),
                            inventory: level.inventory,
                            chipsLeft: level.chipsLeft,
                            hint: level.hint,
                            enemies: level.enemies,
                            blocks: Data_Set["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(dest)(level.blocks),
                            trapConnections: level.trapConnections,
                            ticksLeft: level.ticksLeft,
                            tick: level.tick
                        }));
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return movePlayer(manually)(direction)(Chip_Mutation_Level.moveBlock(dest)(blockDest)(level));
                    };
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Hint) {
                        return movePlayer(manually)(direction)(Chip_Mutation_Level.moveBlock(dest)(blockDest)(level));
                    };
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.TrapButton) {
                        return movePlayer(manually)(direction)(Chip_Mutation_Level.moveBlock(dest)(blockDest)(level));
                    };
                    return Chip_Action.inactive(turned);
                };
                var move = function (v) {
                    return {
                        player: {
                            pos: dest,
                            direction: v.player.direction,
                            turnedAt: v.player.turnedAt,
                            movedAt: v.player.movedAt
                        },
                        tiles: v.tiles,
                        inventory: v.inventory,
                        chipsLeft: v.chipsLeft,
                        hint: v.hint,
                        enemies: v.enemies,
                        blocks: v.blocks,
                        trapConnections: v.trapConnections,
                        ticksLeft: v.ticksLeft,
                        tick: v.tick
                    };
                };
                var openDoor = function (color) {
                    var $145 = Chip_Mutation_Level.onInventory(Chip_Mutation_Inventory.withdrawKey(color));
                    return function ($146) {
                        return Chip_Mutation_Level.removeCurrentTile($145(move($146)));
                    };
                };
                var currentTile = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(level.player.pos)(level.tiles);
                var onIce = (function () {
                    if (currentTile instanceof Data_Maybe.Just && currentTile.value0 instanceof Chip_Model_Tile.Ice) {
                        return true;
                    };
                    if (currentTile instanceof Data_Maybe.Just && currentTile.value0 instanceof Chip_Model_Tile.IceCorner) {
                        return true;
                    };
                    return false;
                })();
                return checkForEnemies((function () {
                    var $53 = {
                        from: Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                            return "y";
                        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                            return "x";
                        }))(Data_Ord.ordInt)))(level.player.pos)(level.tiles),
                        to: Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                            return "y";
                        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                            return "x";
                        }))(Data_Ord.ordInt)))(dest)(level.tiles)
                    };
                    if ($53.from instanceof Data_Maybe.Just && ($53.from.value0 instanceof Chip_Model_Tile.Trap && Chip_Model_Level.isActiveTrap(level.player.pos)(level))) {
                        return sound(Chip_Action.Oof.value)(turned);
                    };
                    if ($53.from instanceof Data_Maybe.Just && ($53.from.value0 instanceof Chip_Model_Tile.Wall && ($53.from.value0.value0 instanceof Chip_Model_WallType.Flat && Data_Eq.eq(Chip_Model_Direction.eqDirection)($53.from.value0.value0.value0)(direction)))) {
                        return sound(Chip_Action.Oof.value)(turned);
                    };
                    if (Data_Set.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(dest)(level.blocks)) {
                        return pushBlock(Chip_Mutation_Point.adjustPoint(dest)(direction));
                    };
                    if ($53.to instanceof Data_Maybe.Nothing && Chip_Model_Level.outOfLevel(dest)) {
                        return sound(Chip_Action.Oof.value)(turned);
                    };
                    if (manually && (onIce && !Chip_Model_Inventory.has(Chip_Model_Item.SkiSkates.value)(level.inventory))) {
                        return Chip_Action.inactive(level);
                    };
                    if ($53.to instanceof Data_Maybe.Nothing) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Chip) {
                        return Chip_Action.withAction(Chip_Mutation_Level.pickUpChip(moved))(new Chip_Action.PlaySound(Chip_Action.PickUpChip.value));
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Item) {
                        return Chip_Action.withAction(Chip_Mutation_Level.pickUp($53.to.value0.value0)(moved))(new Chip_Action.PlaySound(Chip_Action.PickUpItem.value));
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Door && Chip_Model_Inventory.has(new Chip_Model_Item.Key($53.to.value0.value0))(level.inventory))) {
                        return Chip_Action.withAction(openDoor($53.to.value0.value0)(turned))(new Chip_Action.PlaySound(Chip_Action.DoorOpen.value));
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Door) {
                        return Chip_Action.withAction(turned)(new Chip_Action.PlaySound(Chip_Action.Oof.value));
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Wall && $53.to.value0.value0 instanceof Chip_Model_WallType.Solid)) {
                        return sound(Chip_Action.Oof.value)(turned);
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Wall && $53.to.value0.value0 instanceof Chip_Model_WallType.Invisible)) {
                        return sound(Chip_Action.Oof.value)(turned);
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Wall && $53.to.value0.value0 instanceof Chip_Model_WallType.Hidden)) {
                        return sound(Chip_Action.Oof.value)({
                            player: turned.player,
                            tiles: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(dest)(new Chip_Model_Tile.Wall(Chip_Model_WallType.Solid.value))(turned.tiles),
                            inventory: turned.inventory,
                            chipsLeft: turned.chipsLeft,
                            hint: turned.hint,
                            enemies: turned.enemies,
                            blocks: turned.blocks,
                            trapConnections: turned.trapConnections,
                            ticksLeft: turned.ticksLeft,
                            tick: turned.tick
                        });
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Wall && $53.to.value0.value0 instanceof Chip_Model_WallType.Blue)) {
                        return sound(Chip_Action.Oof.value)({
                            player: turned.player,
                            tiles: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(dest)(new Chip_Model_Tile.Wall(Chip_Model_WallType.Solid.value))(turned.tiles),
                            inventory: turned.inventory,
                            chipsLeft: turned.chipsLeft,
                            hint: turned.hint,
                            enemies: turned.enemies,
                            blocks: turned.blocks,
                            trapConnections: turned.trapConnections,
                            ticksLeft: turned.ticksLeft,
                            tick: turned.tick
                        });
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Wall && $53.to.value0.value0 instanceof Chip_Model_WallType.Fake)) {
                        return Chip_Action.inactive(Chip_Mutation_Level.removeCurrentTile(moved));
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Wall && $53.to.value0.value0 instanceof Chip_Model_WallType.Recessed)) {
                        return Chip_Action.inactive({
                            tiles: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(dest)(new Chip_Model_Tile.Wall(Chip_Model_WallType.Solid.value))(moved.tiles),
                            blocks: moved.blocks,
                            chipsLeft: moved.chipsLeft,
                            enemies: moved.enemies,
                            hint: moved.hint,
                            inventory: moved.inventory,
                            player: moved.player,
                            tick: moved.tick,
                            ticksLeft: moved.ticksLeft,
                            trapConnections: moved.trapConnections
                        });
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.Wall && $53.to.value0.value0 instanceof Chip_Model_WallType.Flat)) {
                        var $91 = Data_Eq.eq(Chip_Model_Direction.eqDirection)($53.to.value0.value0.value0)(Chip_Mutation_Direction.invert(direction));
                        if ($91) {
                            return Chip_Action.inactive(turned);
                        };
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Teleport) {
                        var v = nextTeleport(true)(dest)(direction)(level);
                        if (v instanceof Data_Maybe.Just) {
                            return Chip_Action.addAction(new Chip_Action.PlaySound(Chip_Action.Teleported.value))(movePlayerTo(manually)(direction)(v.value0)(level));
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return sound(Chip_Action.Teleported.value)({
                                player: {
                                    pos: level.player.pos,
                                    direction: Chip_Mutation_Direction.invert(direction),
                                    turnedAt: level.player.turnedAt,
                                    movedAt: level.player.movedAt
                                },
                                tiles: level.tiles,
                                inventory: level.inventory,
                                chipsLeft: level.chipsLeft,
                                hint: level.hint,
                                enemies: level.enemies,
                                blocks: level.blocks,
                                trapConnections: level.trapConnections,
                                ticksLeft: level.ticksLeft,
                                tick: level.tick
                            });
                        };
                        throw new Error("Failed pattern match at Chip.Action.MovePlayer (line 70, column 28 - line 72, column 82): " + [ v.constructor.name ]);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Thief) {
                        return sound(Chip_Action.Steal.value)({
                            player: moved.player,
                            tiles: moved.tiles,
                            inventory: Chip_Model_Inventory.initInventory,
                            chipsLeft: moved.chipsLeft,
                            hint: moved.hint,
                            enemies: moved.enemies,
                            blocks: moved.blocks,
                            trapConnections: moved.trapConnections,
                            ticksLeft: moved.ticksLeft,
                            tick: moved.tick
                        });
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Force) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Ice) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.IceCorner) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Bomb) {
                        return Chip_Action.withAction(moved)(new Chip_Action.Die(Chip_Model_DieReason.BlownUp.value));
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Water) {
                        return stepInWater(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Fire) {
                        return stepInFire(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.WallButton) {
                        return Chip_Action.inactive(Chip_Mutation_Level.toggleWalls(moved));
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.TankButton) {
                        return Chip_Action.inactive(Chip_Mutation_Level.toggleTanks(moved));
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.CloneMachineButton) {
                        return Chip_Action.inactive(turned);
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.SwitchableWall && $53.to.value0.value0 instanceof Chip_Model_SwitchState.On)) {
                        return Chip_Action.inactive(turned);
                    };
                    if ($53.to instanceof Data_Maybe.Just && ($53.to.value0 instanceof Chip_Model_Tile.SwitchableWall && $53.to.value0.value0 instanceof Chip_Model_SwitchState.Off)) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Hint) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Dirt) {
                        return Chip_Action.inactive(Chip_Mutation_Level.removeCurrentTile(moved));
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Gravel) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Socket) {
                        return Chip_Action.inactive(Chip_Mutation_Level.moveToSocket(dest)(level));
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Exit) {
                        return Chip_Action.withAction(moved)(Chip_Action.Complete.value);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.CloneMachine) {
                        return Chip_Action.inactive(turned);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.Trap) {
                        return Chip_Action.inactive(moved);
                    };
                    if ($53.to instanceof Data_Maybe.Just && $53.to.value0 instanceof Chip_Model_Tile.TrapButton) {
                        return Chip_Action.inactive(moved);
                    };
                    throw new Error("Failed pattern match at Chip.Action.MovePlayer (line 27, column 21 - line 115, column 24): " + [ $53.constructor.name ]);
                })());
            };
        };
    };
};
var movePlayer = function (manually) {
    return function (direction) {
        return function (level) {
            return movePlayerTo(manually)(direction)(Chip_Mutation_Point.adjustPoint(level.player.pos)(direction))(level);
        };
    };
};
module.exports = {
    movePlayer: movePlayer,
    checkForEnemies: checkForEnemies
};
